import { Form, Input, type InputProps } from 'antd'

interface Props {
  error: string | undefined
  inputProps: InputProps
  label: string
  touched: boolean | undefined
  style?: React.CSSProperties
}

type Value = (string | number) & (string | number | readonly string[])

const TextInput = ({
  children,
  error,
  inputProps,
  label,
  touched,
  style,
}: React.PropsWithChildren<Props>) => {
  const { prefix, size, value, ...restInputProps } = inputProps

  return (
    <Form.Item
      style={style}
      validateStatus={error ? 'error' : 'success'}
      hasFeedback={touched}
      label={(touched && error) || label}
    >
      <Input
        value={value as Value}
        size={typeof size === 'number' ? size : undefined}
        prefix={null}
        {...restInputProps}
      />
      {children}
    </Form.Item>
  )
}

export default TextInput
